import { render, staticRenderFns } from "./supplierDeliveryDetail.vue?vue&type=template&id=3eb15e04&scoped=true"
import script from "./supplierDeliveryDetail.vue?vue&type=script&lang=js"
export * from "./supplierDeliveryDetail.vue?vue&type=script&lang=js"
import style0 from "./supplierDeliveryDetail.vue?vue&type=style&index=0&id=3eb15e04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb15e04",
  null
  
)

export default component.exports